import { communityStats } from '@/mocks/articles';

export default function CommunityStats() {
  const stats = [
    { label: '社区成员', value: communityStats.totalMembers.toLocaleString(), icon: 'ri-user-heart-line', suffix: '+' },
    { label: '文章总数', value: communityStats.totalArticles.toLocaleString(), icon: 'ri-article-line', suffix: '+' },
    { label: '互动评论', value: communityStats.totalComments.toLocaleString(), icon: 'ri-chat-smile-2-line', suffix: '+' },
    { label: '月活跃用户', value: communityStats.monthlyActiveUsers.toLocaleString(), icon: 'ri-fire-line', suffix: '+' },
  ];

  return (
    <section className="w-full py-14 md:py-20 bg-gradient-to-br from-primary-50 via-background-50 to-accent-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            社区数据一览
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            百合会汇聚了来自全国各地的百合文化爱好者，一起看看我们的社区有多活跃
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="text-center p-6 md:p-8 rounded-xl bg-background-50 border border-background-200/70"
            >
              <div className="w-12 h-12 mx-auto mb-4 rounded-xl bg-primary-100 flex items-center justify-center">
                <i className={`${stat.icon} text-xl text-primary-600`}></i>
              </div>
              <div className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-1">
                {stat.value}
                <span className="text-primary-500">{stat.suffix}</span>
              </div>
              <div className="text-sm text-foreground-600">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}